import { NgClass } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { IconComponent } from "@components/icon/icon.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { orderBy } from "lodash";
import { ExternArbetsorderViewModel } from "../../models/ExternArbetsorderViewModel";
import { ExternArbetsorderService } from "../../services/externArbetsorder.service";

@Component({
    selector: "rask-extern-arbetsorder-search-result",
    templateUrl: "./extern-arbetsorder-search-result.component.html",
    styleUrls: ["./extern-arbetsorder-search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        IconComponent,
        NgClass
    ]
})
export class ExternArbetsorderSearchResultComponent {
    protected searchResult: ExternArbetsorderViewModel[] = [];

    protected readonly externArbetsorderService = inject(ExternArbetsorderService);

    constructor() {
        this.externArbetsorderService.searchResult$.subscribe(x => {
            this.searchResult = orderBy(x, y => y.senastUppdaterad, "desc");
        });
    }

    getIcon(row: ExternArbetsorderViewModel): string {
        return this.externArbetsorderService.getIcon(row.externArbetsorderStatus, row.viol3Dirty, row.viol3Fel);
    }
}
